import imag from './ramyabanners/1.png'
import imag2 from './ramyabanners/new banner 2 eco.png'
import imag3 from './ramyabanners/3.png'
import imag4 from './ramyabanners/new banner 1 eco.png'
import imag5 from './ramyabanners/5.png'
import imag6 from './ramyabanners/2.png'
import imag7 from './ramyabanners/4.png'

export const homeCarouselData=[
     {
        image:imag,
     
    },
     {
        image:imag2,
        
    },
    {
        image:imag3,
    
    },
    {
        image:  imag4,
      
    },
    {
        image:imag6,
    
    },
    {
        image:imag5,
    },
    {
        image:imag7,
    }


]

